import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import Swal from 'sweetalert2';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';

/**
 * ConfirmCompleteComponent — small confirmation sub-modal opened
 * from the ordini-da-firmare list to confirm "complete this order?".
 *
 * Phase 1.5 / v2.7.0 — TS cleaned up (Chunk D.3):
 *   • dropped 4 kendo-dialog sizing leftovers (`maxlength`,
 *     `minWidth`, `dialogWidth`, `dialogHeight`),
 *   • dropped 1 console.log,
 *   • switch to inject() (no Subscriptions to track).
 *
 * Behaviour preserved 1:1: emits modalClosed on Yes, fires the
 * Swal "Annullato" toast on No, closes via openModal.offConfirmComplete().
 */
@Component({
  selector: 'app-confirm-complete',
  templateUrl: './confirm-complete.component.html',
  styleUrls: ['./confirm-complete.component.scss'],
  standalone: false,
})


export class ConfirmCompleteComponent {

  public readonly openModal = inject(OpenModalService);

  @Output() modalClosed = new EventEmitter<void>();
  @Input() modalOpened = false;
  @Input() order_id = '-1';

  onNoClick(): void {
    this.openModal.offConfirmComplete();
    Swal.fire({
      icon: 'info',
      title: 'Annullato',
      text: 'Operazione annullata, nulla è stato modificato.',
      timer: 1500,
      timerProgressBar: true,
      showConfirmButton: false,
    });
  }

  onYesClick(): void {
    this.modalClosed.emit();
    this.openModal.offConfirmComplete();
  }
  
}
